// components/AuxiliaryFolderCards.js
import { Link } from 'react-router-dom';

/**
 * Renders auxiliary folder cards.
 * `buildTo(folder)` must return the link target for that folder.
 */
export default function AuxiliaryFolderCards({ folders, buildTo, state, fallbackImage = '/assets/cards/chapter.png' }) {
  if (!folders?.length) return null;

  const fallbackOnce = (e, fallbackUrl) => {
    const img = e.currentTarget;
    if (img.dataset.fallbackApplied) {
      img.style.display = 'none';
      return;
    }
    img.dataset.fallbackApplied = '1';
    img.src = fallbackUrl;
  };

  return (
    <div className="grid-autofit" style={{ marginTop: '1rem' }}>
      {folders.map((folder) => {
        const to = buildTo(folder);
        const count = folder.resources_count ?? folder.resources?.length ?? 0;
        return (
          <article key={folder.id} className="c-card">
            <Link to={to} state={state} aria-label={folder.title}>
              <img
                className="c-card__media"
                src={folder.image || fallbackImage}
                alt={folder.title}
                loading="lazy"
                onError={(e) => fallbackOnce(e, fallbackImage)}
              />
            </Link>
            <div className="c-card__body">
              <h3 className="c-card__title">
                <Link to={to} state={state}>{folder.title}</Link>
              </h3>
              <p className="c-card__meta">{count} פריטים</p>
            </div>
          </article>
        );
      })}
    </div>
  );
}

